// Recovered compiled webpack factory 87317. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      abortTask: function () {
        return h;
      },
      listenForDynamicRequest: function () {
        return p;
      },
      startPPRNavigation: function () {
        return u;
      },
      updateCacheNodeOnPopstateRestoration: function () {
        return function e(t, r) {
          let n = r[1],
            a = t.parallelRoutes,
            i = new Map(a);
          for (let t in n) {
            let r = n[t],
              s = r[0],
              l = (0, o.createRouterCacheKey)(s),
              u = a.get(t);
            if (void 0 !== u) {
              let n = u.get(l);
              if (void 0 !== n) {
                let a = e(n, r),
                  o = new Map(u);
                (o.set(l, a), i.set(t, o));
              }
            }
          }
          let s = t.rsc,
            l = g(s) && "pending" === s.status;
          return {
            lazyData: null,
            rsc: s,
            head: t.head,
            prefetchHead: l ? t.prefetchHead : [null, null],
            prefetchRsc: l ? t.prefetchRsc : null,
            loading: t.loading,
            parallelRoutes: i,
            navigatedAt: t.navigatedAt,
          };
        };
      },
    }));
  let n = r(65360),
    a = r(7460),
    o = r(69190),
    i = r(44707),
    s = r(83571),
    l = { route: null, node: null, dynamicRequestTree: null, children: null };
  function u(e, t, r, i, s, u, d, p, h) {
    return (function e(t, r, i, s, u, d, p, h, _, m, g) {
      let y = i[1],
        v = s[1],
        b = null !== d ? d[2] : null;
      u || (!0 === s[4] && (u = !0));
      let E = r.parallelRoutes,
        R = new Map(E),
        P = {},
        S = null,
        O = !1,
        T = {};
      for (let r in v) {
        let i,
          s = v[r],
          f = y[r],
          d = E.get(r),
          w = null !== b ? b[r] : null,
          j = s[0],
          x = m.concat([r, j]),
          A = (0, o.createRouterCacheKey)(j),
          C = void 0 !== f ? f[0] : void 0,
          M = void 0 !== d ? d.get(A) : void 0;
        if (
          null !==
          (i =
            j === n.DEFAULT_SEGMENT_KEY
              ? void 0 !== f
                ? { route: f, node: null, dynamicRequestTree: null, children: null }
                : c(t, f, s, M, u, void 0 !== w ? w : null, p, h, x, g)
              : _ && 0 === Object.keys(s[1]).length
                ? c(t, f, s, M, u, void 0 !== w ? w : null, p, h, x, g)
                : void 0 !== f &&
                    void 0 !== C &&
                    (0, a.matchSegment)(j, C) &&
                    void 0 !== M &&
                    void 0 !== f
                  ? e(t, M, f, s, u, w, p, h, _, x, g)
                  : c(t, f, s, M, u, void 0 !== w ? w : null, p, h, x, g))
        ) {
          if (null === i.route) return l;
          (null === S && (S = new Map()), S.set(r, i));
          let e = i.node;
          if (null !== e) {
            let t = new Map(d);
            (t.set(A, e), R.set(r, t));
          }
          let t = i.route;
          P[r] = t;
          let n = i.dynamicRequestTree;
          null !== n ? ((O = !0), (T[r] = n)) : (T[r] = t);
        } else ((P[r] = s), (T[r] = s));
      }
      if (null === S) return null;
      let w = {
        lazyData: null,
        rsc: r.rsc,
        prefetchRsc: r.prefetchRsc,
        head: r.head,
        prefetchHead: r.prefetchHead,
        loading: r.loading,
        parallelRoutes: R,
        navigatedAt: t,
      };
      return { route: f(s, P), node: w, dynamicRequestTree: O ? f(s, T) : null, children: S };
    })(e, t, r, i, !1, s, u, d, p, [], h);
  }
  function c(e, t, r, n, a, u, c, p, h, _) {
    return !a && (void 0 === t || (0, i.isNavigatingToNewRootLayout)(t, r))
      ? l
      : (function e(t, r, n, a, i, l, u, c) {
          let p,
            h,
            _,
            m,
            g = r[1],
            y = 0 === Object.keys(g).length;
          if (void 0 !== n && n.navigatedAt + s.DYNAMIC_STALETIME_MS > t)
            ((p = n.rsc), (h = n.loading), (_ = n.head), (m = n.navigatedAt));
          else if (null === a) return d(t, r, null, i, l, u, c);
          else if (((p = a[1]), (h = a[3]), (_ = y ? i : null), (m = t), a[4] || (l && y)))
            return d(t, r, a, i, l, u, c);
          let v = null !== a ? a[2] : null,
            b = new Map(),
            E = void 0 !== n ? n.parallelRoutes : null,
            R = new Map(E),
            P = {},
            S = !1;
          if (y) c.push(u);
          else
            for (let r in g) {
              let n = g[r],
                a = null !== v ? v[r] : null,
                s = null !== E ? E.get(r) : void 0,
                f = n[0],
                d = u.concat([r, f]),
                p = (0, o.createRouterCacheKey)(f),
                h = e(t, n, void 0 !== s ? s.get(p) : void 0, a, i, l, d, c);
              b.set(r, h);
              let _ = h.dynamicRequestTree;
              null !== _ ? ((S = !0), (P[r] = _)) : (P[r] = n);
              let m = h.node;
              if (null !== m) {
                let e = new Map();
                (e.set(p, m), R.set(r, e));
              }
            }
          return {
            route: r,
            node: {
              lazyData: null,
              rsc: p,
              prefetchRsc: null,
              head: _,
              prefetchHead: null,
              loading: h,
              parallelRoutes: R,
              navigatedAt: m,
            },
            dynamicRequestTree: S ? f(r, P) : null,
            children: b,
          };
        })(e, r, n, u, c, p, h, _);
  }
  function f(e, t) {
    let r = [e[0], t];
    return (2 in e && (r[2] = e[2]), 3 in e && (r[3] = e[3]), 4 in e && (r[4] = e[4]), r);
  }
  function d(e, t, r, n, a, i, s) {
    let l = f(t, t[1]);
    return (
      (l[3] = "refetch"),
      {
        route: t,
        node: (function e(t, r, n, a, i, s, l) {
          let u = r[1],
            c = null !== n ? n[2] : null,
            f = new Map();
          for (let r in u) {
            let n = u[r],
              d = null !== c ? c[r] : null,
              p = n[0],
              h = s.concat([r, p]),
              _ = (0, o.createRouterCacheKey)(p),
              m = e(t, n, void 0 === d ? null : d, a, i, h, l),
              g = new Map();
            (g.set(_, m), f.set(r, g));
          }
          let d = 0 === f.size;
          d && l.push(s);
          let p = null !== n ? n[1] : null,
            h = null !== n ? n[3] : null;
          return {
            lazyData: null,
            parallelRoutes: f,
            prefetchRsc: void 0 !== p ? p : null,
            prefetchHead: d ? a : [null, null],
            loading: void 0 !== h ? h : null,
            rsc: y(),
            head: d ? y() : null,
            navigatedAt: t,
          };
        })(e, t, r, n, a, i, s),
        dynamicRequestTree: l,
        children: null,
      }
    );
  }
  function p(e, t) {
    t.then(
      (t) => {
        let { flightData: r } = t;
        if ("string" != typeof r) {
          for (let t of r) {
            let { segmentPath: r, tree: n, seedData: i, head: s } = t;
            i &&
              (function (e, t, r, n, i) {
                let s = e;
                for (let e = 0; e < t.length; e += 2) {
                  let r = t[e],
                    n = t[e + 1],
                    o = s.children;
                  if (null !== o) {
                    let e = o.get(r);
                    if (void 0 !== e) {
                      let t = e.route[0];
                      if ((0, a.matchSegment)(n, t)) {
                        s = e;
                        continue;
                      }
                    }
                  }
                  return;
                }
                !(function e(t, r, n, i) {
                  if (null === t.dynamicRequestTree) return;
                  let s = t.children,
                    l = t.node;
                  if (null === s) {
                    null !== l &&
                      ((function e(t, r, n, i, s) {
                        let l = r[1],
                          u = n[1],
                          c = i[2],
                          f = t.parallelRoutes;
                        for (let t in l) {
                          let r = l[t],
                            n = u[t],
                            i = c[t],
                            d = f.get(t),
                            p = r[0],
                            h = (0, o.createRouterCacheKey)(p),
                            m = void 0 !== d ? d.get(h) : void 0;
                          void 0 !== m &&
                            (void 0 !== n && (0, a.matchSegment)(p, n[0]) && null != i
                              ? e(m, r, n, i, s)
                              : _(r, m, null));
                        }
                        let d = t.rsc,
                          p = i[1];
                        null === d ? (t.rsc = p) : g(d) && d.resolve(p);
                        let h = t.head;
                        g(h) && h.resolve(s);
                      })(l, t.route, r, n, i),
                      (t.dynamicRequestTree = null));
                    return;
                  }
                  let u = r[1],
                    c = n[2];
                  for (let t in r) {
                    let r = u[t],
                      n = c[t],
                      o = s.get(t);
                    if (void 0 !== o) {
                      let t = o.route[0];
                      if ((0, a.matchSegment)(r[0], t) && null != n) return e(o, r, n, i);
                    }
                  }
                })(s, r, n, i);
              })(e, r, n, i, s);
          }
          h(e, null);
        }
      },
      (t) => {
        h(e, t);
      },
    );
  }
  function h(e, t) {
    let r = e.node;
    if (null === r) return;
    let n = e.children;
    if (null === n) _(e.route, r, t);
    else for (let e of n.values()) h(e, t);
    e.dynamicRequestTree = null;
  }
  function _(e, t, r) {
    let n = e[1],
      a = t.parallelRoutes;
    for (let e in n) {
      let t = n[e],
        i = a.get(e);
      if (void 0 === i) continue;
      let s = t[0],
        l = (0, o.createRouterCacheKey)(s),
        u = i.get(l);
      void 0 !== u && _(t, u, r);
    }
    let i = t.rsc;
    g(i) && (null === r ? i.resolve(null) : i.reject(r));
    let s = t.head;
    g(s) && s.resolve(null);
  }
  let m = Symbol();
  function g(e) {
    return e && e.tag === m;
  }
  function y() {
    let e,
      t,
      r = new Promise((r, n) => {
        ((e = r), (t = n));
      });
    return (
      (r.status = "pending"),
      (r.resolve = (t) => {
        "pending" === r.status && ((r.status = "fulfilled"), (r.value = t), e(t));
      }),
      (r.reject = (e) => {
        "pending" === r.status && ((r.status = "rejected"), (r.reason = e), t(e));
      }),
      (r.tag = m),
      r
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
